import { createAction, union } from '@ngrx/store';

export const storeErrorMessage = createAction(
  'ReauthActions storeErrorMessage',
  (payload: string) => ({ payload }),
);

export const reauthSuccess = createAction(
  'ReauthActions reauthSuccess',
  (payload: boolean) => ({ payload }),
);

export const updateLoading = createAction(
  'ReauthActions updateLoading',
  (payload: boolean) => ({ payload }),
);

export const showReauthModal = createAction(
  'ReauthActions showReauthModal',
  (payload: boolean) => ({ payload }),
);

export const resetState = createAction('ReauthActions resetState');

const all = union({
  storeErrorMessage,
  resetState,
  reauthSuccess,
  updateLoading,
  showReauthModal,
});
export type ReauthActionsUnion = typeof all;
